import {
	Directive,
	ElementRef,
	Renderer
} from '@angular/core'

@Directive({
	selector: '[autoGrow]',
	host: {
		'(focus)': 'onFocus()',
		'(blur)': 'onBlur()'
	}
})

export class AutoGrowDirective{

	constructor(private elem: ElementRef, private renderer: Renderer){

	}

	onFocus(){
		this.renderer.setElementStyle(this.elem, 'width', '200');
	}

	onBlur(){
		this.renderer.setElementStyle(this.elem, 'width', '200');
	}
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/directives/auto-grow.directive.ts